import { css } from '@microsoft/fast-element';

export const MoreInfoModalStyles = css`
  :host {
    position: relative;
  }
    .content {
        font-size: 13px;
        color: var(--font-color-1);
        margin: 10px;
    }
    
    a {
        color: var(--white-smoke);
    }
`;
